import type { Route } from './route';

export type Activity = 'run' | 'walk' | 'bike';

export type SaveResponse = { id: string };

export async function saveRoute(
  route: Route,
  opts: { activity: Activity; snap: boolean; name?: string },
): Promise<string> {
  const res = await fetch('/api/routes', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: opts.name ?? '',
      activity: opts.activity,
      snap: opts.snap,
      waypoints: route.waypoints.map((w) => [w.lng, w.lat]),
      geometry: route.geometry(),
      meters: Math.round(route.meters),
    }),
  });
  if (!res.ok) throw new Error(`save: ${res.status}`);
  const data = (await res.json()) as SaveResponse;
  return data.id;
}

export type LoadedRoute = {
  id: string;
  name: string;
  activity: Activity;
  snap: boolean;
  waypoints: Array<[number, number]>;
  geometry: Array<[number, number]>;
  meters: number;
};

export async function loadRoute(id: string): Promise<LoadedRoute | null> {
  const res = await fetch(`/api/routes/${id}`);
  if (!res.ok) return null;
  return (await res.json()) as LoadedRoute;
}
